var render = function render(){var _vm=this,_c=_vm._self._c;return _c('g',[_c('path',{staticClass:"path",attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M1 1.1712H31V30.9657H1V1.1712Z","stroke":"#E4EAEF","stroke-width":"2"}}),_vm._v(" "),_c('rect',{staticClass:"rect",attrs:{"x":"9","y":"15.0753","width":"14","height":"1.9863","rx":"0.993151","fill":"#D3D5D8"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }